export enum PageName {
    PurchasingOrders = "purchasing-orders",
    PurchaseRequests = "purchase-requests",
    PurchaseInvoices = "purchase-invoices",
    Promotions = "pos-promotions",
    Products = "pos-products",
    DebitNotes = "debit-notes",
    CreditNotes = "credit-notes",
    DeliveryZones = "delivery-zones",
    UserManagement = "user-management",
    SalesInvoices = "sales-invoices",
    PurchasingProducts = "purchasing-products",
    PurchasingSuppliers = "purchasing-suppliers",
    PurchasingLocations = "purchasing-locations",
    BillOfMaterial = "bill-of-material",
    ProductionOrder = "production-order",
    SalesOrdersV2_Edara2 = "sales-orders-v2-edara2.0-src",
    SalesOrdersV2_Edara2_5 = "sales-orders-v2-edara2.5-src",
    SalesOrdersV2_Both = "sales-orders-v2-both-src",
    SalesOrdersV2_Form = "sales-orders-v2-form",
    SalesOrdersV2_ExchangeForm = "sales-orders-v2-exchange-form",
    CashManagement = "pos-cash-management",
    FixedAssets = "fixed-assets",
    CashRegisters = "pos-cash-registers",
    Payments = "payments",
    SubscriptionsProducts = "subscriptions-products",
    SubscriptionsCustomers = "subscriptions-customers",
    SubscriptionsPlans = "subscriptions-plans",
    Subscriptions = "subscriptions-subscriptions",
    SubscriptionsCycles = "subscriptions-cycles"
}